/**
 * Фокус на поле БЕЗ прокрутки страницы.
 *
 * Штатный атрибут `autoFocus` заставляет браузер прокрутить ближайший
 * прокручиваемый блок, чтобы показать элемент в фокусе. Для всплывающих
 * списков это ломает вид: список позиционирован фиксированно относительно
 * окна, но в дереве документа остаётся внутри карточки, поэтому браузер
 * прокручивает карточку к началу — пользователь теряет место, где работал.
 *
 * `focus({ preventScroll: true })` ставит фокус, не трогая прокрутку.
 */

import { useLayoutEffect, useRef } from 'react';

export function useAutoFocus<T extends HTMLElement>(active = true) {
  const ref = useRef<T>(null);

  useLayoutEffect(() => {
    if (!active) return;
    ref.current?.focus({ preventScroll: true });
  }, [active]);

  return ref;
}
